// extracted by mini-css-extract-plugin
export default {"rippleContainer":"Ripple_rippleContainer__FfSO9","ripple":"Ripple_ripple__TPX+U"};